<template>
  <div>
    <v-main>
        <v-container>
            <div class="pt-5 pb-5 pl-5 pr-5">
                <v-row>
                    <v-col>
                        <v-row>
                            <v-icon class="mdi-36px">
                            mdi-store
                        </v-icon>
                        <h1 style="margin: 0; color: #929395">Dashboard</h1>
                        <v-text-field>h</v-text-field>
                        </v-row>

                    </v-col>
                </v-row>
            </div>
        </v-container>

    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
// import DateRangePicker from 'vue2-daterange-picker'
// you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import adminLeftMenu from '../Sidebar.vue' // เมนู
export default {
  name: 'home',
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      //   date: [],
      MonthYear: [],
      status: true,
      tab: null,
      chartData: null,
      firstDay: 0,
      format: 'yyyy-mm-dd',
      paramStatus: true,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/Core/Home'
        }
      ],
      session: this.$session.getAll(),
      formAudience: {
        audiencesCode: '',
        audiencesName: '',
        audiencesLevel: '',
        audiencesExchangeRate: '',
        audiencesGender: '',
        audiencesBranch: '',
        audiencesAge: '',
        audiencesVisit: '',
        audiencesReward: '',
        audiencesStr: '',
        audiencesEnd: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      formAdd: {},
      audience: [],
      dataAdd: 0,
      statusButton: '',
      dataMember: [],
      dataAudience: [],
      filterAudience: [],
      data: []
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  created () {
    this.$root.$on('setData', item => {
      this.setData(item)
    })
  },
  async mounted () {
    // this.chkAudience()
    if (this.$route.query.callBack) {
      this.$router.push(
        this.$route.query.callBack +
          '&rewardId=' +
          this.$route.query.rewardId +
          '&rewardCode=' +
          this.$route.query.rewardCode +
          '&lineUserId=' +
          this.$route.query.lineUserId
      )
    }
  },
  methods: {
    getMonthYear () {
      this.MonthYear = this.date.split(',').join()
    },
    async getMember () {
      await axios
        .get(
          this.DNS_IP +
            '/member/get?shopId=' +
            this.session.data.shopId +
            '&CONDITION_TERM2=True'
        )
        .then(res => {
          console.log('res', res)
          if (res.data.status === false) {
            this.dataMember = []
          } else {
            this.dataMember = res.data
            console.log('dataMember', this.dataMember)
          }
        })
    },
    setData (item) {
      if (
        this.audience.filter(el => {
          return el.type === item.type
        }).length === 0
      ) {
        this.audience.push(item)
      } else {
        let objIndex = this.audience.findIndex(obj => obj.type === item.type)
        this.audience[objIndex].id = item.id
        this.audience[objIndex].name = item.name
      }
    },
    // getId () {
    //   this.audience.map(key => {
    //     if (key.type === 'Level') {
    //       this.formAudience.audiencesLevel = key.id
    //       this.formAudience.str = key.str
    //     } else if (key.type === 'Age') {
    //       this.formAudience.audiencesAge = key.id
    //       this.formAudience.str = key.str
    //     } else if (key.type === 'Branch') {
    //       this.formAudience.audiencesBranch = key.id
    //       this.formAudience.str = key.str
    //     } else if (key.type === 'Service') {
    //       this.formAudience.audiencesExchangeRate = key.id
    //       this.formAudience.str = key.str
    //       this.formAudience.end = key.end
    //     } else if (key.type === 'Page') {
    //       this.formAudience.audiencesVisit = key.id
    //       this.formAudience.str = key.str
    //     } else if (key.type === 'Reward') {
    //       this.formAudience.audiencesReward = key.id
    //       this.formAudience.str = key.str
    //     } else {
    //       this.formAudience.audiencesGender = key.id
    //       this.formAudience.str = key.str
    //     }
    //   })
    // },
    async chkAudience () {
      await this.getMember()
      this.dataAdd = 0
      this.filterAudience = []
      this.audience.map(async el => {
        if (el.type === 'Service') {
          await axios
            .get(
              this.DNS_IP +
                '/qrcode/Audience?shopId=' +
                this.session.data.shopId +
                '&productExchangeRateId=' +
                el.id +
                '&LAST_DATE=' +
                el.str +
                ' ' +
                el.end
            )
            .then(res => {
              console.log('res', res.data)
              let Service = []
              if (res.data.status === false) {
                Service = []
              } else {
                Service = res.data
                console.log('Service', Service)
                let a = Service.filter(
                  val => val.productExchangeRateId === el.id
                )
                console.log('a', a)
                let serviceFilter = new Set(
                  a.map(({ liffUserId }) => liffUserId)
                )
                console.log(
                  'serviceFilter',
                  this.dataMember.filter(
                    el => el.liffUserId === 'U417326b09b92594c8f9408885ce747ec'
                  )
                )
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    serviceFilter.has(liffUserId)
                  )
                ]
                console.log('memberFilter', memberFilter)
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                console.log('fil', this.filterAudience)
                this.formAudience.audiencesExchangeRate = el.id
              }
            })
        } else if (el.type === 'Branch') {
          await axios
            .get(
              this.DNS_IP +
                '/qrcode/Audience?shopId=' +
                this.session.data.shopId +
                '&masBranchID=' +
                el.id +
                '&LAST_DATE=' +
                el.str +
                ' ' +
                el.end
            )
            .then(res => {
              let Branch = []
              if (res.data === false) {
                Branch = []
              } else {
                Branch = res.data
                let a = Branch.filter(val => val.masBranchID === el.id)
                let branchFilter = new Set(
                  a.map(({ liffUserId }) => liffUserId)
                )
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    branchFilter.has(liffUserId)
                  )
                ]
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                console.log(this.filterAudience)
                this.formAudience.audiencesBranch = el.id
              }
            })
        } else if (el.type === 'Level') {
          await axios
            .get(
              this.DNS_IP +
                '/member/get?shopId=' +
                this.session.data.shopId +
                '&levelId=' +
                el.id +
                '&CREATE_DATE=' +
                el.str +
                ' ' +
                el.end +
                '&CONDITION_TERM2=True'
            )
            .then(res => {
              //   console.log('resL', res)
              let Level = []
              if (res.data === false) {
                Level = []
              } else {
                Level = res.data
                let a = Level.filter(
                  val => val.levelId.toString() === el.id.toString()
                )
                console.log('aL', a)
                let levelFilter = new Set(a.map(({ liffUserId }) => liffUserId))
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    levelFilter.has(liffUserId)
                  )
                ]
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                this.formAudience.audiencesLevel = el.id
                console.log(this.filterAudience)
              }
            })
        } else if (el.type === 'Gender') {
          await axios
            .get(
              this.DNS_IP +
                '/member/get?shopId=' +
                this.session.data.shopId +
                '&Gender=' +
                el.id +
                '&CREATE_DATE=' +
                el.str +
                ' ' +
                el.end +
                '&CONDITION_TERM2=True'
            )
            .then(res => {
              console.log('res.data', res.data)
              let Gender = []
              if (res.data === false) {
                Gender = []
              } else {
                Gender = res.data
                let a = Gender.filter(val => val.gender === el.id)
                let genderFilter = new Set(
                  a.map(({ liffUserId }) => liffUserId)
                )
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    genderFilter.has(liffUserId)
                  )
                ]
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                this.formAudience.audiencesGender = el.id
              }
            })
        } else if (el.type === 'Age') {
          await axios
            .get(
              this.DNS_IP +
                '/member/get?shopId=' +
                this.session.data.shopId +
                '&title=' +
                el.id +
                '&CREATE_DATE=' +
                el.str +
                ' ' +
                el.end +
                '&CONDITION_TERM2=True'
            )
            .then(res => {
              let Age = []
              if (res.data === false) {
                Age = []
              } else {
                Age = res.data
                let a = Age.filter(val => val.title === el.id)
                let ageFilter = new Set(a.map(({ liffUserId }) => liffUserId))
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    ageFilter.has(liffUserId)
                  )
                ]
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                this.formAudience.audiencesAge = el.id
              }
            })
        } else if (el.type === 'Page') {
          await axios
            .get(
              this.DNS_IP +
                '/TransactionVisitPage/get?shopId=' +
                this.session.data.shopId +
                '&page=' +
                el.id +
                '&CREATE_DATE=' +
                el.str +
                ' ' +
                el.end
            )
            .then(res => {
              let Page = []
              if (res.data === false) {
                Page = []
              } else {
                Page = res.data
                let a = Page.filter(val => val.page === el.id)
                let pageFilter = new Set(
                  a.map(({ CREATE_USER }) => CREATE_USER)
                )
                console.log(pageFilter)
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    pageFilter.has(liffUserId)
                  )
                ]
                console.log(memberFilter)
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                this.formAudience.audiencesVisit = el.id
              }
            })
        } else {
          await axios
            .get(
              this.DNS_IP +
                '/TransactionVisitPage/get?shopId=' +
                this.session.data.shopId +
                '&rewardId=' +
                el.id +
                '&CREATE_DATE=' +
                el.str +
                ' ' +
                el.end
            )
            .then(res => {
              console.log(el.id)
              let rewardId = []
              if (res.data === false) {
                rewardId = []
              } else {
                rewardId = res.data
                let a = rewardId.filter(val => val.rewardId === el.id)
                let rewardFilter = new Set(
                  a.map(({ CREATE_USER }) => CREATE_USER)
                )
                let memberFilter = [
                  ...this.dataMember.filter(({ liffUserId }) =>
                    rewardFilter.has(liffUserId)
                  )
                ]
                console.log(memberFilter)
                memberFilter.forEach(el => {
                  this.filterAudience.push(el)
                })
                this.formAudience.audiencesReward = el.id
              }
            })
        }
        let val = this.filterAudience.map(item => {
          return item.liffUserId
        })
        console.log('fil', val)
        this.dupCounts(val)
        console.log('counts', this.dupCounts(val))
        let idLiffuser = Object.keys(this.dupCounts(val))
        console.log('idLiffuser', idLiffuser)
        let data = idLiffuser
          .map(item =>
            this.dataMember.filter(item2 => item2.liffUserId === item)
          )
          .flat()
        console.log('ddddd', data)
        this.dataAdd = data.length
      })
    },
    dupCounts (val) {
      var counts = {}
      val.forEach(function (n) {
        counts[n] = counts[n] || 0
        counts[n]++
      })

      // iterate counts object and remove any that aren't dups
      for (var key in counts) {
        if (counts[key] < this.audience.length) {
          delete counts[key]
        }
      }
      return counts
    },
    routePage (path) {
      this.$router.push(path)
    },
    async manage () {
      this.paramStatus = false
      this.$refs.modal1.getData(this.dateRange, this.paramStatus)
      this.$refs.modal2.getData(this.dateRange, this.paramStatus)
      this.$refs.modal3.getData(this.dateRange, this.paramStatus)
      this.$refs.modal4.getData(this.dateRange, this.paramStatus)

      this.$refs.modal5.branchNameData(this.dateRange)
      this.$refs.modal6.serviceData(this.dateRange)
      this.$refs.modal7.getData(this.dateRange)

      this.$refs.modal8.getData(this.dateRange, this.paramStatus)
      this.$refs.modal9.init(this.dateRange)
      await this.$refs.modal9.axisX(this.dateRange)
      this.$refs.modal9.getChart()
      this.$refs.modal10.init(this.dateRange)
      await this.$refs.modal10.axisX(this.dateRange)
      this.$refs.modal10.getChart()

      this.$refs.modal11.Level(this.dateRange)
      this.$refs.modal12.gender(this.dateRange)
      this.$refs.modal13.getData(this.dateRange)

      this.$refs.modal14.getData(this.dateRange, this.paramStatus)

      this.$refs.modal15.branchNameData(this.dateRange)
      this.$refs.modal16.init(this.dateRange)
      await this.$refs.modal16.axisX(this.dateRange)
      this.$refs.modal16.getChart()
    },
    addDataAudience () {
      this.chkAudience()
      this.formAudience.audiencesStr = this.dateRange.startDate
      this.formAudience.audiencesEnd = this.dateRange.endDate
      this.formAudience.CREATE_USER = this.$session.getAll().data.userName
      this.formAudience.LAST_USER = this.$session.getAll().data.userName
      this.formAudience.audiencesCode = 'Das_' + this.generateCodeGlobal()
      //   console.log(this.formAudience.audiencesCode)
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(result => {
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + '/audiences/add',

            this.formAudience
          )
          .then(async response => {
            // Debug response
            console.log('addDataGlobal DNS_IP + PATH + "add"', response)
            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
            // Close Dialog
            // Load Data
            this.clear()
          })
      })
    },
    remove (item) {
      console.log(item.type)
      if (item.type === 'Level') {
        this.formAudience.audiencesLevel = ''
        this.filterAudience = []
      } else if (item.type === 'Age') {
        this.formAudience.audiencesAge = ''
        this.filterAudience = []
      } else if (item.type === 'Branch') {
        this.formAudience.audiencesBranch = ''
        this.filterAudience = []
      } else if (item.type === 'Service') {
        this.formAudience.audiencesExchangeRate = ''
        this.filterAudience = []
      } else if (item.type === 'Page') {
        this.formAudience.audiencesVisit = ''
        this.filterAudience = []
      } else if (item.type === 'Reward') {
        this.formAudience.audiencesReward = ''
        this.filterAudience = []
      } else {
        this.formAudience.audiencesGender = ''
        this.filterAudience = []
      }
      this.audience.splice(this.audience.indexOf(item), 1)
      this.audience = [...this.audience]
      console.log('aa', this.audience)
      if (this.audience.length === 0) {
        this.dataAdd = 0
      }
      //   this.chkAudience()
    },
    clear () {
      this.formAudience.audiencesName = ''
      this.formAudience.audiencesLevel = ''
      this.formAudience.audiencesAge = ''
      this.formAudience.audiencesBranch = ''
      this.formAudience.audiencesExchangeRate = ''
      this.formAudience.audiencesGender = ''
      this.dataAdd = 0
      this.audience = []
    }
  }
}
</script>
<style scoped>
.v-text-field {
  padding: 10px 10px 0px !important;
}
.theme--light.v-input input {
  color: rgba(0, 0, 0, 0.87);
  /* text-align: center; */
}
.bg-ac {
  background: linear-gradient(180deg, #ade1ff 0%, #f6fcff 100%);
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
}
.bg-color-blue {
  background: linear-gradient(180deg, #1e9cd7 0%, #c0dbf2 100%);
  box-shadow: 0px 0px 3px rgba(72, 72, 72, 0.75);
}
.bg-color-grey {
  background: linear-gradient(180deg, #d9d9d9 0%, rgba(217, 217, 217, 0) 100%);
  filter: drop-shadow(0px 0px 3px rgba(72, 72, 72, 0.75));
}
.bg-color-white {
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(72, 72, 72, 0.75);
}
.text-darkblue1 {
  color: #170057 !important;
}

@media only screen and (min-width: 1265) and (max-width: 1904) {
  h1 {
    font-size: 30px !important;
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 13px;
  }
  h6 {
    font-size: 10px;
  }
  p {
    font-size: 14px;
  }
}

/* @media only screen and (min-width: 1265px) and (max-width: 1904) {
  h1 {
    font-size: 19px !important;
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 20px !important;
  }
  h5 {
    font-size: 13px;
  }
  h6 {
    font-size: 10px;
  }
  p {
    font-size: 14px;
  }
  .card-min {
    width: 350px;
    height: 250px;
  }
} */

@media only screen and (min-width: 961px) and (max-width: 1264px) {
  h1 {
    font-size: 19px !important;
  }
  h2 {
    font-size: 17px;
  }
  h3 {
    font-size: 15px;
  }
  h4 {
    font-size: 20px !important;
  }
  p {
    font-size: 14px;
  }
  .card-min {
    width: 400px;
    height: 260px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 960px) {
  h1 {
    font-size: 22px !important;
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 54px !important;
    font-weight: 700;
    text-align: center;
    margin: 0px 0px;
  }
  h4 {
    font-size: 44px !important;
    font-weight: 700;
    text-align: center;
  }
  p {
    font-size: 14px;
  }
  .card-min {
    width: 350px;
    height: 250px;
  }
  .iconsize {
    font-size: 40px !important;
  }
  .padding4 {
    padding: 4px 12px;
    text-align: center;
  }
  .weight {
    font-weight: 500;
    padding-left: 15px;
  }
  h5 {
    font-size: 31px !important;
    font-weight: 900;
  }
  .text-center {
    text-align: center;
  }
}

@media screen and (max-width: 600px) {
  h1 {
    font-size: 18px !important;
  }
  h2 {
    font-size: 14px !important;
  }
  h3 {
    font-size: 50px !important;
    font-weight: 700;
    text-align: center;
    margin: 0px 0px;
  }
  h4 {
    font-size: 40px !important;
    font-weight: 700;
    text-align: center;
  }
  h5 {
    font-size: 27px !important;
    font-weight: 900;
  }
  p {
    font-size: 14px;
  }
  .v-text-field {
    padding: 0px !important;
  }
  .weight {
    font-weight: 500;
    padding-left: 15px;
  }
  .card-min {
    width: 350px;
    height: 250px;
  }
  .padding4 {
    padding: 4px 12px;
    text-align: center;
  }
  .iconsize {
    font-size: 36px !important;
  }

  .text-center {
    text-align: center;
  }

  .mar0 {
    margin: 0px;
  }
  .xhidden {
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Core/Home.vue